import React from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import SelectProviderInput from '../providers/SelectProviderInput';
import OneProviderSchedule from '../calendar/OneProviderSchedule';

const getStartAndEndDate = ({date, calendarView}) => {
  if (calendarView === 'week') {
    return {
      startDate: moment(date).startOf('week').toISOString(),
      endDate: moment(date).endOf('week').toISOString(),
    };
  }
};

const AdminSchedulingScreen = ({
  date = new Date(),
  sessions = [],
  awayTimes = [],
  availabilities = [],
  providers = [],
  onChangeProviderIds = (e, val) => console.log('onChangeProvider', e, val),
  onDateChange = (e, val) => console.log('onDateChange', val),
}) => {
  return (
    <Box>
      {
        <SelectProviderInput
          multiple={true}
          onChange={(e, val) => onChangeProviderIds(e, val)}
        />
      }
      <Stack direction='row' spacing={2}>
        {
          providers.map(p => 
            <OneProviderSchedule 
              key={p.id}
              provider={p}
              date={date}
              sessions={sessions}
              awayTimes={awayTimes}
              availabilities={availabilities}
              onDateChange={onDateChange}   
            />
          )
        }
      </Stack>
    </Box>
  );
};

export default AdminSchedulingScreen;